<header [ngClass]="isScroll ? 'fixed-header' : ''" id="headerTop">
    <div class="headerShadow">
        <div class="headerWrapp">
          <div class="cntHead">
            <span class="menuBtn" (click)="onRightPanelClick($event)" *ngIf="isMobile"><mat-icon>menu</mat-icon></span>
            <div class="logo_wrpp">
              <div class="logoItem desktop_vw">
                  <a routerLink="/">
                      <img src="../../../../assets/images/Unibuild_logo.svg" alt="">
                  </a>
              </div>
              <div class="logoItem mobile_vw">
                  <span routerLink="/">
                      <img src="../../../../assets/images/Unibuild_logo.svg" alt="">                     
                  </span>    
              </div>
          </div>
          <div class="menu_list" *ngIf="!isMobile">
              <ul>
                  <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                      <a routerLink="/about">About</a>
                  </li>
                  <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                      <a routerLink="/contact">Contact</a>
                  </li>
                  <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                      <a routerLink="/video">Video</a>
                  </li>
                  <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a routerLink="/events">Events</a>
                </li>
              </ul>
          </div>
          <div class="searchWrapp" *ngIf="!isMobile">
            <ng-container *ngTemplateOutlet="searchBar"></ng-container>
          </div>
          
          <div class="headerButtons">
            
              <ul class="rtLinks">
                <li  (click)="customerSignup()" *ngIf="!isMobile && !tokenItem">
                  <lucide-icon name="briefcase" class="my-icon" [size]="18"></lucide-icon>
                  Buy / Sell
                </li>
                <!-- <li  (click)="customerSignin()" *ngIf="tokenItem">
                  <lucide-icon name="file-text" class="my-icon" [size]="isMobile ? 24 : 18"></lucide-icon>
                  <span *ngIf="!isMobile">View RFQ</span>
                </li>

                <li (click)="logOut()" *ngIf="tokenItem">
                  <lucide-icon name="log-out" color="#444" class="my-icon" [size]="isMobile ? 24 : 18"></lucide-icon>
                  <span *ngIf="!isMobile">Logout</span>
                </li> -->
                <li routerLink="/prelogin" *ngIf="!tokenItem">
                  <lucide-icon name="user" class="my-icon" [size]="isMobile ? 24 : 18"></lucide-icon>
                  <span *ngIf="!isMobile">Sign In</span>
                </li>
              </ul>
              <div class="profileIco customer" *ngIf="tokenItem" [matMenuTriggerFor]="menu">
                <span>{{ nameInitials }}</span>
              </div>
              <div class="cartItem" (click)="nevigateCheckout()">
                <lucide-icon name="shopping-cart" class="my-icon" [size]="24" color="#333"></lucide-icon>
                <span class="count-items">{{ countCartItems }}</span>
              </div>
          </div>
          </div>
        </div>
        <div class="searchHeader" *ngIf="isMobile">
            <div class="cntHead">
              <div class="searchWrapp">
                <ng-container *ngTemplateOutlet="searchBar"></ng-container>
              </div>
            </div>
        </div>
        <div class="megaMenu" *ngIf="!isMobile && megaMenu">
            <div class="cntHead">
              <ul class="parentList">
                <li 
                  *ngFor="let category of categoriesList; let menuIndex = index" 
                  (click)="openMegaMenu(category, menuIndex, $event)" 
                  class="menuItem"
                  [ngClass]="menuIndex === currentMenu && isShowMenu ? 'activeMenu' : ''"
                >
                  <span [ngClass]="{ active: activeListItem == category.category_id }">{{category.name}}</span>
                  <lucide-icon
                    *ngIf="category.children?.length > 0"
                    [name]="getChevronIcon(menuIndex, category)"
                    [size]="16"
                    class="icon">
                  </lucide-icon>
                  <div class="megaMenuContent" *ngIf="menuIndex === currentMenu && category.children.length && isShowMenu">
                    <ng-container *ngTemplateOutlet="menuList; context: { $implicit: selectedCategory }"></ng-container>
                  </div>
                </li>
            </ul>
            </div>
        </div>
    </div>
</header>
<ng-template #menuList let-categoryItems>
  <div class="menuRow">
    <div class="menuBlock" *ngFor="let data of categoryItems.children.slice(0, 10) | sortByOrder: 'name'; trackBy: identify">
      <h3 (click)="getCategoryProduct(data.category_id, data.name, data.slug)">{{data.name}}</h3>
      <ul>
        <!-- <ng-container *ngFor="let subCat of data.children; let itemIndex = index">
          <li 
              *ngIf="itemIndex < 4"
              (click)="getCategoryProduct(subCat.category_id, subCat.name, subCat.slug)"
              >{{subCat.name}}
          </li>
        </ng-container> -->
        <li *ngFor="let subCat of data.children.slice(0, 3)" (click)="getCategoryProduct(subCat.category_id, subCat.name, subCat.slug); setActive(subCat.category_id)">{{subCat.name}}</li>
        <li *ngIf="data.children.length > 3" class="viewAllList" (click)="getCategoryProduct(data.category_id, data.name, data.slug)">
          View All
        </li>
      </ul>
    </div>
    <div class="showAllcategory" *ngIf="categoryItems.children.length > 10">
      <span (click)="getCategoryProduct(categoryItems.category_id, categoryItems.name, categoryItems.slug)">
        View All {{categoryItems.name}}
      </span>
    </div>
    <!-- <img class="menuImg" src="https://develop-shop.unibuild.ai/cache/original/product/78/dvkMllJaWYNHOkh3uM5lXETxd2ILlO3cfjvb0R7R.webp" alt=""> -->
  </div>
</ng-template>
<ng-template #searchBar>
  <form class="searchBox formGroup">
    <mat-form-field class="example-full-width" appearance="outline">
      <input
        matInput
        placeholder="Search products here"
        #searchProducts
        [matAutocomplete]="auto"
        (keyup)="searchByProduct($event)"
      />
      <lucide-icon
        (click)="searchProducts.value = ''"
        class="clear-search-product-icon"
        [name]="searchProducts.value ? 'circle-x' : 'search'"
        color="#6d6d6d"
        [size]="20"
      ></lucide-icon>
      <mat-autocomplete #auto="matAutocomplete">
        <ng-container *ngIf="productList.length; else noproductTemplate">
          <mat-option
            *ngFor="let product of productList"
            [value]="product.name"
            (onSelectionChange)="onProductSelected($event, product.id)"
          >
            <div class="optionItem">
              <img alt="" class="example-option-img" [src]="product.images[0].small_image_url" />
              <span>{{ product.name }}</span>
            </div>
          </mat-option>
        </ng-container>
        <ng-template #noproductTemplate>
          <mat-option *ngIf="showNoData">No Product Found</mat-option>
        </ng-template>
      </mat-autocomplete>
    </mat-form-field>
  </form>
</ng-template>
<div class="layout-rightpanel" [ngClass]="{'layout-rightpanel-active': rightPanelActive}"
    (click)="rightPanelClick = true"  *ngIf="isMobile">
    <div class="sdnvWrpp">
        <div class="sdnvHeader">
            <span (click)="onSidenavClose($event)" class="closeSdnv" id="closeSdnv">
                <mat-icon>close</mat-icon>
            </span>
        </div>
        <div class="sdnvBody">
          <ul class="nav-list">
            <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: sidebarList, level: 1 }"></ng-container>
            <ng-template #recursiveList let-items let-level="level">
              <ng-container *ngFor="let item of items; trackBy: identify">
                <li
                  *ngIf="item.parent_id"
                  class="nav-item"
                  [ngClass]="{
                    level_1: level == 1,
                    level_2: level == 2,
                    level_3: level == 3,
                    level_4: level == 4,
                    'leaf-node': !item.children.length
                  }"
                >
                  <span
                    (click)="getCategoryProduct(item.category_id, item.name, item.slug); setActive(item.category_id)"
                    [ngClass]="{ active: activeListItem == item.category_id }"
                  >
                    {{ item.name }}
                    <!-- <small *ngIf="item.children.length">({{item.children.length}})</small> -->
                  </span>
                  <span (click)="toggleCollapse(item)" *ngIf="item.children && item.children.length" class="colloapseIco">
                    <ng-container *ngIf="isCollapsed(item); else elseTemplate">
                      <lucide-icon name="chevron-down" [size]="16" class="lucid-icon"></lucide-icon>
                    </ng-container>
                    <ng-template #elseTemplate>
                      <lucide-icon name="chevron-right" [size]="16" class="lucid-icon"></lucide-icon>
                    </ng-template>
                  </span>
                  <ul *ngIf="item.children && item.children.length" class="child-menu" [ngClass]="{ showMenu: isCollapsed(item) }">
                    <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: item.children, level: level + 1 }"></ng-container>
                  </ul>
                </li>
              </ng-container>
            </ng-template>
          </ul>
            
        </div>
        
    </div>
</div>
<mat-menu #menu="matMenu">
  <div class="userInfoView">
    <div class="profileIco customer">
      <span>{{ nameInitials }}</span>
    </div>
    <div class="profileDescription">
      <h3>{{ profileName }}</h3>
      <p title="{{userEmail}}">{{ userEmail }}</p>
    </div>
  </div>
  
  <button mat-menu-item class="switchTitle" (click)="redirectDashboard()">
    <lucide-icon name="user-round" [size]="18" color="#666" class="lucide-icon-switch"></lucide-icon>
    My Account
  </button>
  <button mat-menu-item class="switchTitle" (click)="logOut()" *ngIf="tokenItem">
    <lucide-icon name="log-out"  color="#666" [size]="isMobile ? 24 : 18" class="lucide-icon-switch"></lucide-icon>
    Logout
  </button>
  
</mat-menu>
<ng-container #dynamicContainer></ng-container>
